export default __webpack_public_path__ + "static/media/70-TrioOrange.b6081649.jpg";